// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".empty-dash {\n  font-size: 14px !important;\n}", "",{"version":3,"sources":["EmptyDash.css"],"names":[],"mappings":"AAAA;EACE,0BAA0B;AAC5B","file":"EmptyDash.css","sourcesContent":[".empty-dash {\n  font-size: 14px !important;\n}"]}]);
// Exports
module.exports = exports;
